import { render, staticRenderFns } from "./MyCollectionHistory.vue?vue&type=template&id=8b32f19a&scoped=true"
import script from "./MyCollectionHistory.vue?vue&type=script&lang=js"
export * from "./MyCollectionHistory.vue?vue&type=script&lang=js"
import style0 from "./MyCollectionHistory.vue?vue&type=style&index=0&id=8b32f19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b32f19a",
  null
  
)

export default component.exports